<section class="ppp-drivers">
  <header class="ppp-drivers__header">
    <h1>Driver eligibility</h1>
    <p class="ppp-drivers__subtitle">Per-shift rule checks for the selected week.</p>
  </header>

  <form [formGroup]="form" class="ppp-drivers__filters">
    <mat-form-field appearance="outline">
      <mat-label>Week start (Monday)</mat-label>
      <input
        matInput
        [matDatepicker]="weekStartPicker"
        [matDatepickerFilter]="mondayDateFilter"
        formControlName="weekStart"
        readonly
      />
      <mat-datepicker-toggle matSuffix [for]="weekStartPicker"></mat-datepicker-toggle>
      <mat-datepicker #weekStartPicker startView="month"></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select formControlName="status">
        <mat-option value="all">All</mat-option>
        <mat-option value="eligible">Eligible at close</mat-option>
        <mat-option value="notEligible">Not eligible at close</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Region</mat-label>
      <mat-select formControlName="regionId">
        <mat-option [value]="null">All regions</mat-option>
        <mat-option *ngFor="let region of regions$ | async" [value]="region.regionId">
          {{ region.regionName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <p *ngIf="loading$$ | async" class="ppp-drivers__hint">Loading shift evaluations…</p>
  <p *ngIf="error$$ | async as err" class="ppp-drivers__error">{{ err }}</p>

  <ng-container *ngIf="groups$ | async as groups">
    <div *ngIf="groups.length === 0 && (loading$$ | async) === false" class="ppp-drivers__empty">
      No shift evaluations match the current filters.
    </div>

    <div class="ppp-drivers__table-wrapper" *ngIf="groups.length > 0">
      <table mat-table [dataSource]="groups" class="ppp-drivers__table">
        <ng-container matColumnDef="driver">
          <th mat-header-cell *matHeaderCellDef>Driver</th>
          <td mat-cell *matCellDef="let group">
            <div class="ppp-drivers__driver-name">{{ group.driverName }}</div>
            <div class="ppp-drivers__driver-id">#{{ group.driverId }}</div>
          </td>
        </ng-container>

        <ng-container matColumnDef="shifts">
          <th mat-header-cell *matHeaderCellDef>Shifts</th>
          <td mat-cell *matCellDef="let group">{{ group.totalShifts }}</td>
        </ng-container>

        <ng-container matColumnDef="eligible">
          <th mat-header-cell *matHeaderCellDef>Eligible</th>
          <td mat-cell *matCellDef="let group">{{ group.driverEligibleAtCloseCount }} / {{ group.totalShifts }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['driver', 'shifts', 'eligible']"></tr>
        <tr
          mat-row
          *matRowDef="let group; columns: ['driver', 'shifts', 'eligible']; trackBy: trackByGroup"
          class="ppp-drivers__driver-row"
        ></tr>
      </table>

      <details class="ppp-drivers__shifts" *ngFor="let group of groups; trackBy: trackByGroup">
        <summary>
          <strong>{{ group.driverName }}</strong> — {{ group.totalShifts }} shift(s)
        </summary>
        <table mat-table [dataSource]="group.shifts" class="ppp-drivers__shifts-table">
          <ng-container matColumnDef="start">
            <th mat-header-cell *matHeaderCellDef>Start</th>
            <td mat-cell *matCellDef="let s">{{ s.shiftStart | date: 'short' }}</td>
          </ng-container>
          <ng-container matColumnDef="region">
            <th mat-header-cell *matHeaderCellDef>Region</th>
            <td mat-cell *matCellDef="let s">{{ s.regionName }}</td>
          </ng-container>
          <ng-container matColumnDef="eligible">
            <th mat-header-cell *matHeaderCellDef>Eligible</th>
            <td mat-cell *matCellDef="let s">
              <lohi-eligibility-status-chip
                [eligible]="s.driverEligibleAtClose"
                size="sm"
              ></lohi-eligibility-status-chip>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['start', 'region', 'eligible']"></tr>
          <tr
            mat-row
            *matRowDef="let s; columns: ['start', 'region', 'eligible']"
            class="ppp-drivers__shift-row"
            (click)="openShift(s)"
          ></tr>
        </table>
      </details>
    </div>
  </ng-container>
</section>
